<template>
<div>
    <Cabecera />
   <h1>Hola aqui viene despues del correo</h1>
</div>
</template>

<script>
// @ is an alias to /src
import Cabecera from './../components/Cabecera.vue'


export default {
  name: 'pruebaURL',
  components: {
    Cabecera
  }
}
</script>
